import { render } from "./Portfoliomore.vue?vue&type=template&id=8aa5ded6"
import script from "./Portfoliomore.vue?vue&type=script&lang=js"
export * from "./Portfoliomore.vue?vue&type=script&lang=js"

import exportComponent from "D:\\portfolio\\bhavindabhi\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__